export default "__VITE_ASSET__Dz$BPAhg__"